import { render, staticRenderFns } from "./ProviderStat.vue?vue&type=template&id=36f5387e&"
import script from "./ProviderStat.vue?vue&type=script&lang=js&"
export * from "./ProviderStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports